import { HttpStatusCode } from '@/fetch/core/constant';
import { LocalControlButton } from '@/utils/constant';
import { makeFetchSuccessActionType } from '@/utils/makeActionType';
import { createAction, createSlice } from '@reduxjs/toolkit';
import {
  AUTH_TOKEN,
  BASIC_INFO,
  MessageType,
  SYNC_ANDRIOD_CONNECT_STATUS,
  SYNC_OPERATION,
  SCREEN_COCKPIT_TEAM,
} from '../actions/common';
export enum Status {
  UNKNOWN = 'UNKNOWN',
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

const ConnectStatus: any = {
  0: Status.UNKNOWN,
  1: Status.ONLINE,
  2: Status.OFFLINE,
};
export enum OperationType {
  EnterWelcomePage = 'EnterWelcomePage',
  EnterDetectionPage = 'EnterDetectionPage',
  EnterMultiVehiclePage = 'EnterMultiVehiclePage',
  EnterSingleVehiclePage = 'EnterSingleVehiclePage',
}

export const actionClearOperation = createAction('CLEAR_OPRATION');
export const actionAddListenerOperateBtn = createAction(
  'actionAddListenerOperateBtn'
);
export const actionRemoveListenerOperateBtn = createAction(
  'actionRemoveListenerOperateBtn'
);
type CommonState = {
  addListenerLocalControlButton: boolean;
  apiKey: string;
  token: string | null;
  cockpitName: string | null;
  cockpitNumber: string;
  steeringStatus: Status;
  brakeStatus: Status;
  screenStatus: Status;
  androidStatus: Status;
  cockpitTeamNumber: string | null; // 驾舱团队编号
  cockpitUserName: string | null;
  operationData: {
    operateType: OperationType;
    [key: string]: any;
  } | null;
  notWorkTotal: number;
  vehicleTotal: number;
  scheduleVehicleTotal: number;
  atWorkTotal: number;
  onlineVehicleTotal: number;
  localControlButton: LocalControlButton | null;
};

const initState: CommonState = {
  addListenerLocalControlButton: false,
  apiKey: '',
  token: null,
  cockpitName: null,
  cockpitNumber: '',
  steeringStatus: Status.UNKNOWN,
  brakeStatus: Status.UNKNOWN,
  screenStatus: Status.ONLINE,
  androidStatus: Status.UNKNOWN,
  cockpitTeamNumber: '',
  cockpitUserName: null,
  operationData: null,
  notWorkTotal: 0,
  vehicleTotal: 0,
  scheduleVehicleTotal: 0,
  atWorkTotal: 0,
  onlineVehicleTotal: 0,
  localControlButton: null,
};

const commonState = createSlice({
  name: 'common',
  initialState: initState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(MessageType.CONF_INFO, (state: CommonState, action: any) => {
        const res = action.payload;
        const { confInfo } = res;
        state.apiKey = confInfo.apiKey;
        state.cockpitNumber = confInfo.cockpitNo;
      })
      .addCase(
        SYNC_ANDRIOD_CONNECT_STATUS,
        (state: CommonState, action: any) => {
          const res = action.payload;
          const { data } = res;
          state.androidStatus = data.androidStatus;
        }
      )
      .addCase(
        MessageType.CONNECT_STATUS,
        (state: CommonState, action: any) => {
          const res = action.payload;
          const { connectStatus } = res;
          const { brakeStatus, steeringStatus } = connectStatus;
          state.brakeStatus = ConnectStatus[brakeStatus];
          state.steeringStatus = ConnectStatus[steeringStatus];
        }
      )
      .addCase(
        MessageType.STEERING_OPERATE,
        (state: CommonState, action: any) => {
          const res = action.payload;
          const { steeringOperate } = res || {};
          state.localControlButton = steeringOperate?.localControlButton;
        }
      )
      .addCase(
        actionAddListenerOperateBtn,
        (state: CommonState, action: any) => {
          state.addListenerLocalControlButton = true;
          state.localControlButton = null;
        }
      )
      .addCase(
        actionRemoveListenerOperateBtn,
        (state: CommonState, action: any) => {
          state.addListenerLocalControlButton = false;
          state.localControlButton = null;
        }
      )
      .addCase(SYNC_OPERATION, (state: CommonState, action: any) => {
        const res = action.payload;
        const { data } = res;
        if (data?.cockpitUserName) {
          state.cockpitUserName = data?.cockpitUserName;
        }
        state.operationData = data;
      })
      .addCase(
        makeFetchSuccessActionType(AUTH_TOKEN),
        (state: CommonState, action: any) => {
          const res = action.payload;
          state.token = res.data?.accessToken;
        }
      )
      .addCase(
        makeFetchSuccessActionType(BASIC_INFO),
        (state: CommonState, action: any) => {
          const res = action.payload || {};
          if (res.code === HttpStatusCode.Success) {
            state.cockpitTeamNumber = res?.data?.cockpitTeamNumber;
            state.cockpitName = res?.data?.cockpitName;
            state.cockpitUserName = res?.data?.cockpitUserName;
          }
        }
      )
      .addCase(SCREEN_COCKPIT_TEAM, (state, action: any) => {
        const {
          atWorkTotal,
          notWorkTotal,
          scheduleVehicleTotal,
          offlineTotal,
          vehicleTotal,
          onlineVehicleTotal,
        } = action.payload?.data || {};
        state.notWorkTotal = notWorkTotal;
        state.atWorkTotal = atWorkTotal;
        state.scheduleVehicleTotal = scheduleVehicleTotal;
        state.vehicleTotal = vehicleTotal;
        state.onlineVehicleTotal = onlineVehicleTotal;
      })
      .addCase(actionClearOperation, (state, action: any) => {
        state.localControlButton = null;
      });
  },
});

export default commonState.reducer;
